import React from "react";
import "./notificationDropDown.css";
import NotificationData from "../notificationData/NotificationData";
import { handleDropdownClick } from "../../../utils/functions/handleDropdownClick";
const NotificationDropDown = ({ isNotification, menuRef, notificationCount, setDropdownState }) => {
  return (
    <>
      <span
        onClick={() => handleDropdownClick("isNotification", setDropdownState)}
        className="m-nav__link m-dropdown__toggle"
        title="Notifications"
      >
        
        <span
          className="m-nav__link-icon"
          style={{ width: "0px", position: "relative" }}
        >
          <i className="fa fa-bell" style={{ position: "relative" }}>
            <span
              className={`notificationCount justify-content-center align-items-center h-100 w-100 ${
                notificationCount ? "d-flex" : "d-none"
              }`}
              style={{
                position: "absolute",
                top: "-47%",
                right: "-47%",
                background: "red",
                color: "#fff",
                borderRadius: "50%",
                fontSize: "12px",
              }}
              data-darkreader-inline-bgimage
              data-darkreader-inline-bgcolor
              data-darkreader-inline-color
            >
              {notificationCount}
            </span>
          </i>
        </span>
      </span>
      {isNotification&&<div
          className="header-overlay"
          onClick={() =>
            handleDropdownClick("", setDropdownState)
          }
          onContextMenu={() =>
            handleDropdownClick("", setDropdownState)
          }
        ></div>}
      <div
        className={`dropdown-menu notificationDropDown ${
          isNotification ? "show" : "hide"
        }`}
        id="notificationTab"
        ref={menuRef}
        aria-labelledby="dropdownMenuLink"
        style={{ maxHeight: "400px", overflowY: "hidden" }}
      >
        <div className="col-12 d-flex flex-row notificationHeader">
          <div className="col-4 ">Notifications</div>
          <div
            className="col-7 d-flex justify-content-end align-items-center text-end"
            style={{ paddingRight: "0" }}
            id="allNotifications"
            title="All Notifications"
          >
            <u>All Notifications</u>
          </div>
          <div
            className="col d-flex justify-content-end align-items-center px-0"
            style={{ padding: "0" }}
            onClick={()=>handleDropdownClick(!isNotification , setDropdownState)}
          >
            <i className="fa fa-times ps-2" aria-hidden="true"></i>
          </div>
        </div>
        
          <NotificationData />
      </div>
    </>
  );
};

export default NotificationDropDown;
